import { getLocale, getProfileId } from "lib/store";
import { apiClient } from "../api-client";
import {
  BinahSetting,
  HealthReadingDataResponse,
  InititaQRSession,
  ParameterHistory,
  ParameterHistoryParams,
  ReScanConfig,
  ScanLinkChannel,
  ScanReadings,
} from "./type";

export const postHealthReading = async (data: any) => {
  return await apiClient.post(
    `/web_health_reading?os=web&locale=${getLocale()}&profile_id=${getProfileId()}`,
    data
  );
};

export const getHealthReading = async (args?: {
  page_number: number;
  page_size: number;
}) => {
  return await apiClient.get<HealthReadingDataResponse>("/web_health_reading", {
    params: {
      locale: getLocale(),
      profile_id: getProfileId(),
      os: "web",
      page_number: args?.page_number || 1,
      page_size: args?.page_size || 10,
    },
  });
};

export const deleteHealthReading = async (data: { reading_id: string[] }) => {
  return (await apiClient.delete(
    `/web_health_reading?os=web&locale=${getLocale()}&profile_id=${getProfileId()}`,
    { data }
  )) as { success: boolean };
};

export const getBinahSetting = async () => {
  return (await apiClient.get("/face-scan-setting", {
    params: {
      device_type: "web",
      profile_id: getProfileId(),
      locale: getLocale(),
    },
  })) as BinahSetting[];
};

export const postBinahSetting = async (data: string) => {
  return (await apiClient.post(
    `/face-scan-setting?os=web&locale=${getLocale()}&profile_id=${getProfileId()}&device_type=web`,
    {
      pem_key: data,
    }
  )) as BinahSetting[];
};

export const getScanParameterHistory = async (
  params?: ParameterHistoryParams
) => {
  return (await apiClient.get("/parameter_history", {
    params: {
      os: "web",
      profile_id: getProfileId(),
      locale: getLocale(),
      ...(params || {}),
    },
  })) as Record<string, ParameterHistory[]>;
};

export const getReScanConfiguration = async () => {
  return (await apiClient.get("/rescan", {
    params: {
      os: "web",
      profile_id: getProfileId(),
      locale: getLocale(),
      client_name: "medsi_check",
    },
  })) as ReScanConfig;
};

export const getHealthReadingById = async (reading_id?: string) => {
  return await apiClient.get<ScanReadings>("/web_health_reading", {
    params: {
      os: "web",
      locale: getLocale(),
      profile_id: getProfileId(),
      reading_id,
    },
  });
};

export const postScanSession = async ({
  status,
  session_id,
}: {
  session_id?: string;
  status: string;
}) => {
  return (await apiClient.post(
    `/scan-session?os=web&locale=${getLocale()}&profile_id=${getProfileId()}&status=${status}` +
    (session_id ? `&session_id=${session_id}` : "")
  )) as InititaQRSession;
};

export const patchScanSession = async ({
  status,
  session_id,
}: {
  session_id: string;
  status: string;
}) => {
  return await apiClient.patch(
    `/scan-session?os=web&locale=${getLocale()}&profile_id=${getProfileId()}&status=${status}&session_id=${session_id}`
  );
};

export const sendScanLink = async (channel_type: ScanLinkChannel) => {
  return (await apiClient.get(`/send-scan-link`, {
    params: {
      os: "web",
      locale: getLocale(),
      profile_id: getProfileId(),
      channel_type,
    },
  })) as Record<"url" | "session_id", string>;
};

export type FaceScanMediaUploadUrls = {
  upload_url: string;
  json_upload_url: string;
};
export async function getFaceScanMediaUploadUrls(
  readingId: string,
  imageBlob: Blob
): Promise<FaceScanMediaUploadUrls> {
  // const url = `${FACE_SCAN_MEDIA_BASE}?client_name=${CLIENT_NAME}&reading_id=${encodeURIComponent(readingId)}`;
  // const response = await fetch(url, {
  //   method: 'POST',
  //   headers: {
  //     'Content-Type': imageBlob.type || 'image/jpeg',
  //   },
  //   body: imageBlob,
  // });

  // if (!response.ok) {
  //   throw new Error(
  //     `Face scan media API error: ${response.status} ${response.statusText}`
  //   );
  // }

  // const data = (await response.json()) as FaceScanMediaUploadUrls;
  // if (!data.upload_url || !data.json_upload_url) {
  //   throw new Error(
  //     'Face scan media API did not return upload_url and json_upload_url'
  //   );
  // }
  // return data;
  return (await apiClient.post(
    `/user_scan_image?os=web&locale=${getLocale()}&profile_id=${getProfileId()}&reading_id=${readingId}`,
    imageBlob,
    {
      headers: {
        'Content-Type': imageBlob.type || 'image/jpeg',
      },
    }
  )) as FaceScanMediaUploadUrls;
}